import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../app.models';
import { createIsEqualSelector } from '../shared/ngrx/selector.utils';
import { Firmware, firmwareFeatureKey, FirmwareState } from './firmwares.models';

const selectFeature = createFeatureSelector<FirmwareState>(firmwareFeatureKey);

export const selectLoading = createSelector(selectFeature, (state) => state.loading > 0);
export const selectFirmwares = createIsEqualSelector(selectFeature, (state: FirmwareState) => state.firmwares);
export const selectActiveFirmware = createIsEqualSelector(selectFirmwares, (firmwares: Firmware[]) => firmwares.find((fw) => fw.activeOn));
